import React from 'react';
import { PropTypes } from 'prop-types';
import DayPicker from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import { toClass } from 'recompose';

const Calendar = ({
  t,
  locale,
  selectedDays,
  handleChange,
  disabledDays,
  className,
  fromMonth,
  toMonth,
  handleBlur,
  handleKeyDown,
  modifiers,
  month,
  handleDayMouseEnter,
  showHigherPriceWeekendMessage,
  showHigherPriceTodayMessage,
  handleDayMouseLeave,
}) => (
  <div className={className}>
    <DayPicker
      localeUtils={MomentLocaleUtils}
      locale={locale}
      onDayClick={handleChange}
      selectedDays={selectedDays}
      fromMonth={fromMonth}
      toMonth={toMonth}
      disabledDays={disabledDays}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      modifiers={modifiers}
      month={month}
      onDayMouseEnter={handleDayMouseEnter}
      onDayMouseLeave={handleDayMouseLeave}
    />
    <div className="calendar__footer-message">
      {showHigherPriceWeekendMessage && (
        <div className="calendar__footer-message-higher-price">
          <p>{t('higher-price-weekend-message')}</p>
        </div>
      )}
      {showHigherPriceTodayMessage && (
        <div className="calendar__footer-message-higher-price">
          <p>{t('higher-price-today-message')}</p>
        </div>
      )}
    </div>
  </div>
);

Calendar.propTypes = {
  locale: PropTypes.string.isRequired,
  className: PropTypes.string,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleKeyDown: PropTypes.func,
  fromMonth: PropTypes.instanceOf(Date).isRequired,
  toMonth: PropTypes.instanceOf(Date),
  selectedDays: PropTypes.instanceOf(Date),
  disabledDays: PropTypes.shape({
    before: PropTypes.instanceOf(Date),
    after: PropTypes.instanceOf(Date),
  }),
  modifiers: PropTypes.object,
  month: PropTypes.instanceOf(Date),
  showHigherPriceMessage: PropTypes.bool,
  handleDayMouseEnter: PropTypes.func,
  handleDayMouseLeave: PropTypes.func,
};

Calendar.defaultProps = {
  className: '',
  handleChange: () => {},
  handleBlur: () => {},
  handleKeyDown: () => {},
  disabledDays: undefined,
  selectedDays: undefined,
  toMonth: undefined,
  month: undefined,
  modifiers: {},
  showHigherPriceWeekendMessage: false,
  showHigherPriceTodayMessage: false,
};

export default toClass(Calendar);
